import bookmark from "../../data/bookmark.json";
import projects from "../../data/project.json";
import orederhistory from "../../data/orederhistory.json";
import Knowledgebase from "../../data/Knowledgebase.json";
import usercard from "../../data/usercard.json";

const state = {
  bookmark: bookmark.data,
  allprojects: projects.all,
  doingprojects: projects.Doing,
  doneprojects: projects.Done,
  orederhistory: orederhistory.data,
  usercard: usercard.data,
  knowledgebasedata: Knowledgebase.data,
  knowledgebasevideo: Knowledgebase.latest_video,
  favourite: [],
  activeclass: "pills_created",
  headerComponent: {
    title: "",
    subtitle: "",
    showBack: false,
  },
};

const getters = {
  activeclass: (state) => {
    return state.activeclass;
  },
};

const mutations = {
  active: (state, payload) => {
    state.activeclass = payload;
  },
  setFavourite: (state, payload) => {
    let objIndex = state.favourite.findIndex((obj) => obj.id === payload.id);
    if (objIndex > -1) {
      state.favourite.splice(objIndex, 1);
    } else {
      state.favourite.push(payload);
    }
  },
  getActive: (state, payload) => {
    let objIndex = state.favourite.findIndex((obj) => obj.id === payload);
    if (objIndex > -1) {
      return true;
    } else {
      return false;
    }
  },
  add: (state, payload) => {
    state.bookmark.push(payload);
  },
  setHeaderComponent: (state, payload) => {
    state.headerComponent = payload;
  },
  getHeaderComponent: (state) => {
    return state.headerComponent;
  },
};

const actions = {
  active: (context, payload) => {
    context.commit("active", payload);
  },
  setFavourite: (context, payload) => {
    context.commit("setFavourite", payload);
  },
  getActive: (context, payload) => {
    context.commit("getActive", payload);
  },
  setHeaderComponent: (context, payload) => {
    context.commit("setHeaderComponent", payload);
  },
  getHeaderComponent: (context) => {
    context.commit("getHeaderComponent");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
